export default __webpack_public_path__ + "media/plus/plus-look-n-feel-8a75a451.jpg";